export const iconFontAwesomeSecurityBan = (
	<i className="fa-solid fa-ban"></i>
);
